import type { QueryFunctionContext } from '@tanstack/react-query';
import { queryOptions } from '@tanstack/react-query';
import { apiClient } from 'lib/api';
import type { OptionsDTO } from './types';
import type { AdsLibraryApiPathParams } from './parseAdsLibraryApiPath';
import { parseAdsLibraryApiPath } from './parseAdsLibraryApiPath';

export const getAdCompanies = async ({
  signal,
  queryKey,
}: QueryFunctionContext<[string, string]>): Promise<OptionsDTO[]> => {
  const res = await apiClient.get<{ data: OptionsDTO[] }>(queryKey[1], {
    signal,
  });
  return res.data.data;
};

export const getAdCompaniesOptions = (params: AdsLibraryApiPathParams = {}) =>
  queryOptions({
    staleTime: 60 * 60 * 1000,
    queryFn: getAdCompanies,
    queryKey: ['ad-companies', parseAdsLibraryApiPath('ad_companies', params)] as const,
  });
